// VIEWED_HOUSE
export const VIEWED_HOUSE_GRAYSCALE = 'Viewed-House-Icon-Grayscale.svg';
export const VIEWED_HOUSE_COLOR_SMALL = 'Viewed-House-Icon-Color-Small.svg';
export const VIEWED_HOUSE_COLOR = 'Viewed-House-Icon-Color.svg';
export const VIEWED_HOUSE_ANIMATION = 'Viewed-House-Icon-Animation-2x.gif';

// SLP_VIEWED_HOUSE
export const SLP_VIEWED_HOUSE_COLOR = 'Slp-Viewed-House-Icon-Color.svg';
export const SLP_VIEWED_HOUSE_GRAYSCALE = SLP_VIEWED_HOUSE_COLOR;
export const SLP_VIEWED_HOUSE_COLOR_SMALL = SLP_VIEWED_HOUSE_COLOR;
export const SLP_VIEWED_HOUSE_ANIMATION = SLP_VIEWED_HOUSE_COLOR;

// FILLING_HOUSE
export const FILLING_HOUSE_GRAYSCALE = 'Filling-House-Icon-Grayscale.svg';
export const FILLING_HOUSE_COLOR_SMALL = 'Filling-House-Icon-Color-Small.svg';
export const FILLING_HOUSE_COLOR = 'Filling-House-Icon-Color.svg';
export const FILLING_HOUSE_ANIMATION = 'Filling-House-Icon-Animation-2x.gif';

// STAR
export const STAR_GRAYSCALE = 'Star-Icon-Grayscale.svg';
export const STAR_COLOR_SMALL = 'Star-Icon-Color-Small.svg';
export const STAR_COLOR = 'Star-Icon-Color.svg';
export const STAR_ANIMATION = 'Star-Icon-Animation-2x.gif';

// TICK_CALENDAR
export const TICK_CALENDAR_GRAYSCALE = 'Tick-Calendar-Icon-Grayscale.svg';
export const TICK_CALENDAR_COLOR_SMALL = 'Tick-Calendar-Icon-Color-Small.svg';
export const TICK_CALENDAR_COLOR = 'Tick-Calendar-Icon-Color.svg';
export const TICK_CALENDAR_ANIMATION = 'Tick-Calendar-Icon-Animation-2x.gif';

// ALARM_CLOCK
export const ALARM_CLOCK_GRAYSCALE = 'Alarm-Clock-Icon-Greyscale.svg';
export const ALARM_CLOCK_COLOR_SMALL = ALARM_CLOCK_GRAYSCALE;
export const ALARM_CLOCK_COLOR = ALARM_CLOCK_GRAYSCALE;
export const ALARM_CLOCK_ANIMATION = ALARM_CLOCK_GRAYSCALE;
